import apiCall from 'apps/investment/apiCalls/fundAccount';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, EditPage, ListPage } from 'common/ui/admin-CRUD/page';
import ItemForm from './Form';
import { columnsGenerator, filterConfig } from './config';
import ItemDetail from './detail';

export const InvestmentFundAccountListPage = (props, { params }) => (
  <ListPage
    title="All Fund Accounts"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={() => <DynamicFilterForm fields={filterConfig} />}
  />
);

export const InvestmentFundAccountDetailPage = props => (
  <DetailPage
    title="Fund Account"
    apiCall={apiCall}
    listUrl={`/investment/fund-accounts`}
    ItemDetail={ItemDetail}
    resourceName="data"
    {...props}
  />
);

export const InvestmentFundAccountEditPage = props => {
  return (
    <EditPage
      title="Fund Account Edit"
      apiCall={apiCall}
      listUrl={`/investment/fund-accounts`}
      ItemForm={ItemForm}
      options={{ title: 'Edit Fund Account' }}
      resourceName="data"
      {...props}
    />
  );
};
